import { createFileRoute } from '@tanstack/react-router';
import { AutoaprendizadoView } from '@/modules/agentes/components/AutoaprendizadoView';

// Pilar Autoaprendizado do módulo Agentes (gestão) — admin-only (o endpoint
// /api/v2/agentes/autoaprendizado retorna 403 pra não-admin; o nav só aparece
// pra admin).
export const Route = createFileRoute('/_authed/agentes_/autoaprendizado')({
  component: AutoaprendizadoView,
});
